import { useEffect, useState, useRef, React} from 'react';
import { original, rose, vaporwave, matrix } from 'react95/dist/themes';
import { BrowserRouter, Router, Routes, Route, Link, useNavigate} from "react-router-dom";
import { MapContainer, TileLayer, useMap, Marker, Popup, Polygon, Polyline } from 'react-leaflet'
import { createGlobalStyle, ThemeProvider, createTheme} from 'styled-components';
import { markers } from '../images/Markers/markerDir';
import laPlaces from '../Data/LA_County_Cities.json';
import 'leaflet/dist/leaflet.css';
import "../Styles/style.css"
import {
    AppBar,
  Button,
  MenuList,
  MenuListItem,
  ScrollView,
  Separator,
  Toolbar,
    Frame,
  Window,
    Handle,
    
  WindowContent,
  WindowHeader,
    TextInput,
    styleReset
} from 'react95';

import starFull from "../images/Stars/starFull.png"
import starEmpty from "../images/Stars/starEmpty.png"
import L from 'leaflet';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';



const defaultIcon = (props) => L.icon({
  iconUrl: props.IconUrl,
  shadowUrl: markerShadow,
  iconSize: [70, 70],
  iconAnchor: [35, 70],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});


const colors = {
  1: "#cc0021",
  2: "#e60025",
  3: "#ff002a",
  4: "#ff1a40",
  5: "#ff3356",
  6: "#ff4d6d",
  7: "#ff6683",
  8: "#ff8099",
  9: "#ff99b0",
  10: "#ffb3c6",
};

const AboutPage = () => {

    const stars = Array(10).fill(0)
    const imgBox = useRef(null);
    const descBox = useRef(null);
    
    const navigate = useNavigate();
    
    const handleRedirect = (dir) => {
            navigate(dir);
        };
    
    const [neighborhoodBoundaries, setNeighborhoodBoundaries] = useState([]);
    const [transitLines, setTransitLines] = useState([]);
    const [error, setError] = useState(null);

    const NEIGHBORHOODS = [
        {
            Name: "Hollywood",
            Walkability_Score: 9,
            Overall_Score: 10,
            Queerness_Score: 8,
            Bark: "A beautiful, chaotic mess of a neighborhood that is the best of LA ",
            Description: "LA is at its finest when it embraces its messiest contradictions. Make no mistake, Hollywood is a town of contradictions. Despite its image as the entertainment capital of the world, very few studios are located here. With only Paramount calling this neighborhood its home. This sets up an expectation amongst many transplants and tourists of glitz and glamour. Of meeting a celebrity. Of ending up in a movie by some convoluted sequence of events. Inevitably this results in a feeling of disappointment when they realize that Hollywood is more akin to a twinkling, tweaker filled tourist trap. This disappointment when they realize that the heights of celebrity you’ll ever witness is a niche transsexual blogger you follow online (Kat Blaque hmu) leads many to write it off as irrelevant. However, reality could not be further from this. Nay Hollywood, holds the untamable, unpredictable, unmarketable spirit of this city. Like Times Square in the 80s, the grime is not a bug, it’s a feature. It’s what makes this place come alive. It’s where friends hangout after school. Where people have their first dates with the loves of their lives. Where a girl can go to decompress after a long day at a shitty job. And sure all those experiences may come along with the occasional tweaker with shit running down his leg experiencing god, or the occasional overpriced scam of a tourist trap, or the odd bit of harassment. But that’s what makes it all alive. This is LA in its purest form, crowded, untamable, and chaotic. When people ask me what to do on Hollywood Boulevard all I can say is just “it”, you just do “it”. “It’s” that undeniable potential of being in LA. Of letting the beauty and the chaos of the world take you like a current on a storm. Letting yourself become one with the city and allowing yourself to experience the pure catharsis of its rapture. Hollywood is like a messy In-n-Out burger on a hot day with some Anita Baker in the background. It’s a mess, maybe a little cheap and trashy at times, could maybe hurt you. But my god does the salt of those fries and the juiciness of that burger feel borderline orgasmic. It’s a vibe like none other. Hollywood may not be for everyone. It sure as hell is trashy and trash ain’t for everyone. But as a mistress of garbage, Hollywood is just my kinda neighborhood. So come up around sometime, try the bike lanes on Hollywood Boulevard. Take the Red Line up and walk Sunset. Grab a cheap bite "
        },
        {
            Name: "North Hollywood",
            Walkability_Score: 8,
            Overall_Score: 9,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Exposition Park",
            Walkability_Score: 9,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Downtown",
            Walkability_Score: 10,
            Overall_Score: 10,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Koreatown",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Sherman Oaks",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "University Park",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Westlake",
            Walkability_Score: 8,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Silver Lake",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Studio City",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Hollywood Hills",
            Walkability_Score: 3,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Los Feliz",
            Walkability_Score: 5,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "East Hollywood",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Hancock Park",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Pico-Union",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Bel-Air",
            Walkability_Score: 2,
            Overall_Score: 1,
            Queerness_Score: 2,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Beverly Crest",
            Walkability_Score: 2,
            Overall_Score: 3,
            Queerness_Score: 2,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Hollywood Hills West",
            Walkability_Score: 2,
            Overall_Score: 5,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Westwood",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Brentwood",
            Walkability_Score: 2,
            Overall_Score: 4,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Sawtelle",
            Walkability_Score: 6,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Pacific Palisades",
            Walkability_Score: 2,
            Overall_Score: 7,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Mar Vista",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Venice",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Westchester",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "West Los Angeles",
            Overall_Score: 7,
            Walkability_Score: 6,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Century City",
            Walkability_Score: 7,
            Overall_Score: 5,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Palms",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "West Adams",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Adams-Normandie",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Jefferson Park",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Mid-City",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Fairfax",
            Walkability_Score: 7,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Beverly Grove",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Mid-Wilshire",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Windsor Square",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Echo Park",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Chinatown",
            Walkability_Score: 8,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Vermont Square",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Hyde Park",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Leimert Park",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Historic South-Central",
            Walkability_Score: 6,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Florence",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Vermont-Slauson",
            Overall_Score: 7,
            Walkability_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Vermont Knolls",
            Overall_Score: 7,
            Queerness_Score: 7,
            Walkability_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Boyle Heights",
            Walkability_Score: 6,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Van Nuys",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Encino",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Lake Balboa",
            Walkability_Score: 5,
            Overall_Score: 6,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Northridge",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Granada Hills",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Porter Ranch",
            Walkability_Score: 3,
            Overall_Score: 3,
            Queerness_Score: 3,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Chatsworth",
            Walkability_Score: 4,
            Overall_Score: 4,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Reseda",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "North Hills",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Canoga Park",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "West Hills",
            Walkability_Score: 5,
            Overall_Score: 5,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Woodland Hills",
            Walkability_Score: 4,
            Overall_Score: 7,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Tarzana",
            Walkability_Score: 3,
            Overall_Score: 4,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Toluca Lake",
            Walkability_Score: 3,
            Overall_Score: 5,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Valley Glen",
            Walkability_Score: 5,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Panorama City",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Sun Valley",
            Walkability_Score: 2,
            Overall_Score: 4,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Griffith Park",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Eagle Rock",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Highland Park",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Atwater Village",
            Walkability_Score: 7,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Winnetka",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Playa Vista",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },



      
      // add more as needed
    ];
    
    const CITIES = [
        
        {
            Name: "West Hollywood city",
            Walkability_Score: 9,
            Overall_Score: 8,
            Queerness_Score: 9,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Inglewood city",
            Walkability_Score: 7,
            Overall_Score: 9,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Beverly Hills city",
            Walkability_Score: 7,
            Overall_Score: 1,
            Queerness_Score: 2,
            Bark: "Miserable Shithole of wealthy asshats. Where good taste and empathy goes to die.",
            Description: "Ever since I've been able to explore this city on my own, Beverly Hills is the SOLE area I have made a conscious effort to avoid as much as possible. Any time I find myself unfortunate enough to pass through it I experience an instinctual revulsion that compels me to exit as soon as possible. It is the municipal distillation of everything wrong with the greedy, selfish, sociopathic, lecherous and unfeeling elite we've created in this country. From the automotive choices that reek of nouveau riches desperation, architecture that can only be described as the Disneyland version of Los Angeles, and the most horrific and inhuman policies in the county towards homelessness. It is as if a looksmaxxer created a city. Their children idolize genocidal rapists. Their parents attempt to veto vital transportation infrastructure for no reason. Their stores are vapid and expensive. Their policies to this day are racist and classist. In a just world it would've been smote in some sort of biblical wrath, with high density affordable housing, public parks, diverse vegetation and elevated rail built in its ashes. If Beverly Hills has no haters, then it means I am dead. Beverly hills is the absolute definition of “fuck you, got mine”. It’s where class traitors of the working classes go to microwave their brains with fintech bro slop. To take all their wealth they’ve violently stolen from the hardworking people of this country and hoard it in the form of the most tackiest, gauche, uninteresting, and straight up distasteful art, real estate and luxury groceries. It’s not just that they’re inhuman wealth hoarders, there are many such cases of them (Hell you can make a good case for my family being that) and they don’t cause as much sickening rage to me as the residents of Beverly Hills. Nay, it’s not just that it’s a city full of selfish, malthusian, leeches. It's a city of selfish, malthusian, leeches who have no class, no taste, no style, no substance, and yet demand to be taken seriously. Being in Beverly Hills for five minutes would turn a Trump supporter into a landlord beheading Maoist. The people who live in Beverly Hills have sold their souls to capital. There is nothing left. They are husks who cannot think or feel, only act in whatever way protects their proximity to such tacky and shitlike capital. Beverly Hills has taken so much from this city and to a lesser extent, this world and has only given one good thing in return... the cheesecake factory. With that being said I am incredibly excited to ride the D line out there when the next phase opens in 2027 so I can tap dance in front of that shitty high school. Me and all my homeless tweaker buddies!"
        },
        {
            Name: "Santa Monica city",
            Walkability_Score: 9,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Long Beach city",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 8,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Culver City city",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Huntington Park city",
            Walkability_Score:7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Vernon city",
            Walkability_Score: 1,
            Overall_Score: 2,
            Queerness_Score: 5,
            Bark: "Why are you here?",
            Description: "Why are you trying to go to Vernon, California? There is positively nothing here whatsoever. There is a reason why this city as of 2026 has a population of 112. Because there is nothing good in vernon. Vernon is a bunch of warehouses, railyards, battery recycling facilities, data centers, and chemical plants in a trenchcoat pretending to be a city. Vernon is an anti-place. It's somewhere you exist only to work and nothing more. It is one of many places in America where people sacrifice their mind, body and soul to the capitalist machine for scraps. Vernon sucks, it's miserable, but also it's a vital part of what keeps the economy running in this city. It's existence is necessary for capital to survive. Places like Vernon are necessary to keep the machine running. Nobody really wants Vernon, but also as long as we remain afraid of alternatives to free market neoliberal capitalism Vernon is what we will get and what we deserve. Honestly, unlike Beverly Hills I really get no joy whatsoever from ragging on Vernon. It's not really the fault of anyone who actual spends time there and builds the place that it's like that. It just kinda... is. Vernon sucks but in just a sad and pathetic way. With its proximity to downtown there was so much potential for something more but instead it just sits there. Its most notable acheivement in recent years being working towards blocking a rail project that would massively improve travel times for... you guessed it, an irrational fear of even a slight drop in profits. Talking about Vernon makes me miserable, so I'm going to stop."
        },
        {
            Name: "Hawthorne city",
            Walkability_Score: 4,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Lawndale city",
            Walkability_Score: 2,
            Overall_Score: 2,
            Queerness_Score: 3,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Manhattan Beach city",
            Walkability_Score: 9,
            Overall_Score: 8,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "El Segundo city",
            Walkability_Score: 7,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Hermosa Beach city",
            Walkability_Score: 9,
            Overall_Score: 8,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Redondo Beach city",
            Walkability_Score: 8,
            Overall_Score: 9,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Torrance city",
            Walkability_Score: 7,
            Overall_Score: 8,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Rancho Palos Verdes city",
            Walkability_Score: 1,
            Overall_Score: 2,
            Queerness_Score: 3,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Palos Verdes Estates city",
            Walkability_Score: 1,
            Overall_Score: 3,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Burbank city",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Glendale city",
            Walkability_Score: 3,
            Overall_Score: 5,
            Queerness_Score: 4,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "San Fernando city",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Pasadena city",
            Walkability_Score: 8,
            Overall_Score: 8,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Alhambra city",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Monterey Park city",
            Walkability_Score: 7,
            Overall_Score: 7,
            Queerness_Score: 7,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "El Monte city",
            Walkability_Score: 6,
            Overall_Score: 6,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "West Covina city",
            Walkability_Score: 5,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Compton city",
            Walkability_Score: 6,
            Overall_Score: 7,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Arcadia city",
            Walkability_Score: 5,
            Overall_Score: 6,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Santa Clarita city",
            Walkability_Score: 3,
            Overall_Score: 6,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Palmdale city",
            Walkability_Score: 3,
            Overall_Score: 5,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Malibu city",
            Walkability_Score: 4,
            Overall_Score: 8,
            Queerness_Score: 6,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Calabasas city",
            Walkability_Score: 2,
            Overall_Score: 3,
            Queerness_Score: 2,
            Bark: "Test Bark",
            Description: "Test Description"
        },
        {
            Name: "Valencia city",
            Walkability_Score: 3,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },{
            Name: "Avalon city",
            Walkability_Score: 3,
            Overall_Score: 6,
            Queerness_Score: 5,
            Bark: "Test Bark",
            Description: "Test Description"
        },
    ];
    
    const MetroLines = [
                        {
                            Object_ID: 941,
                            RealName: "B Line",
                            Color: "#ec1f25",
                            Land_Use_Score: 9,
                            Reliability_Score: 7,
                            Safety_Score: 7,
                            Vibes_Score: 9,
                            Overall_Score: 8,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 938,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "B Line",
                            Color: "#ec1f25",
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 938,
                            RealName: "D Line",
                            Color: "#9f5ea6",
                            OFFSET_LAT: -0.0005,
                            OFFSET_LNG: 0,
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 933,
                            RealName: "D Line",
                            Color: "#9f5ea6",
                            OFFSET_LAT: -0.0005,
                            OFFSET_LNG: 0,
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 943,
                            RealName: "D Line",
                            Color: "#9f5ea6",
                            OFFSET_LAT: -0.0005,
                            OFFSET_LNG: 0,
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 935,
                            Name: "Orange Line",
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "G Line",
                            Color: "#f26522",
                            Bark: "Test Bark",
                            Description: "Test Description"
                        },
                        {
                            Object_ID: 940,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0.0005,
                            RealName: "A Line",
                            Color: "#0072bc",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 934,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "K Line",
                            Color: "#e96bb0",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 937,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "E Line",
                            Color: "#da9f2a",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 948,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "E Line",
                            Color: "#da9f2a",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 939,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "E Line",
                            Color: "#da9f2a",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 949,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "E Line",
                            Color: "#da9f2a",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 939,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0.0005,
                            RealName: "A Line",
                            Color: "#0072bc",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 949,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0.0005,
                            RealName: "A Line",
                            Color: "#0072bc",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 936,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0.0005,
                            RealName: "A Line",
                            Color: "#0072bc",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 942,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "C Line",
                            Color: "#459644",
                            Bark: "",
                            Description: ""
                        },
                        {
                            Object_ID: 934,
                            OFFSET_LAT: 0,
                            OFFSET_LNG: 0,
                            RealName: "K Line",
                            Color: "#e96bb0",
                            Bark: "",
                            Description: ""
                        },
    ];
    
    const neighborhoodMap = new Map(NEIGHBORHOODS.map(neighborhood => [neighborhood.Name, neighborhood]));
    
    useEffect(() => {
      fetch('https://raw.githubusercontent.com/blackmad/neighborhoods/master/los-angeles.geojson')
        .then(res => res.json())
        .then(data => {
          const matched = data.features.filter(f =>
                                               NEIGHBORHOODS.some(NEIGHBORHOOD => NEIGHBORHOOD.Name === f.properties.name)
          );

          const neighborhoodBoundaries = matched.map(feature => {
            const neighborhoodData = neighborhoodMap.get(feature.properties.name);
            const geom = feature.geometry;
            const rings = geom.type === 'MultiPolygon'
              ? geom.coordinates[0][0]
              : geom.coordinates[0];
              const entry = {
                  Name: feature.properties.name,
                  Bark: neighborhoodData.Bark,
                  Commentary: neighborhoodData.Description,
                  walkabilityScore: neighborhoodData.Walkability_Score,
                  overallScore: neighborhoodData.Overall_Score,
                  queernessScore: neighborhoodData.Queerness_Score,
                  coords: rings.map(([lng, lat]) => [lat, lng]),
              }
            return {
                entry
            };
          });

          setNeighborhoodBoundaries(neighborhoodBoundaries); // array of { name, coords }
        });
    }, []);
    
    const metroLineMap = new Map();
    MetroLines.forEach(MetroLine => {
      if (!metroLineMap.has(MetroLine.Object_ID)) {
        metroLineMap.set(MetroLine.Object_ID, []);
      }
      metroLineMap.get(MetroLine.Object_ID).push(MetroLine);
    });
    
    useEffect(() => {
      fetch('https://services.arcgis.com/RmCCgQtiZLDCtblq/arcgis/rest/services/MTA_Metro_Lines/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson')
        .then(res => res.json())
        .then(data => {
          const matched = data.features.filter(f =>
                                               MetroLines.some(MetroLine => MetroLine.Object_ID === f.properties.OBJECTID)
          );

            const transitLines = matched.flatMap(feature => {
              const metroLineEntries = metroLineMap.get(feature.properties.OBJECTID) ?? [];

              return metroLineEntries.map(metroLineData => {
                // ... your coord logic here ...

                  const geom = feature.geometry;
                    let coordinates;
                    if (geom.type === 'LineString') {
                        coordinates = geom.coordinates.map(([lng, lat]) => [lat + metroLineData.OFFSET_LAT, lng + metroLineData.OFFSET_LNG]);
                    } else if (geom.type === 'MultiLineString') {
                        coordinates = geom.coordinates.map(segment =>
                                segment.map(([lng, lat]) => [lat + metroLineData.OFFSET_LAT, lng])
                            );
                    } else if (geom.type === 'Polygon') {
                        coordinates = geom.coordinates[0].map(([lng, lat]) => [lat, lng]);
                    } else {
                        coordinates = [];
                    }
                  
                return {
                  entry: {
                      Name: metroLineData.RealName,
                      Bark: metroLineData.Bark,
                      Color: metroLineData.Color,
                      Commentary: metroLineData.Description,
                      coords: coordinates,
                  }
                };
              });
            });
            
          

          setTransitLines(transitLines); // array of { name, coords }
        });
    }, []);
    
    const cityMap = new Map(CITIES.map(city => [city.Name, city]));
    
    const cityBoundaries = laPlaces.features
      .filter(f => CITIES.some(city => city.Name === f.properties.NAME))
      .map(feature => {
        const cityData = cityMap.get(feature.properties.NAME);
        const geom = feature.geometry;
        const rings = geom.type === 'MultiPolygon'
          ? geom.coordinates[0][0]
          : geom.coordinates[0];
          
          const entry = {
              Name: feature.properties.NAME.replace("city", "").trim(),
              Bark: cityData.Bark,
              Commentary: cityData.Description,
              walkabilityScore: cityData.Walkability_Score,
              overallScore: cityData.Overall_Score,
              queernessScore: cityData.Queerness_Score,
              coords: rings.map(([lng, lat]) => [lat, lng]),
          }
        return {
            entry
            
        };
      });
    
    const Entries = [
        
        {
            Name: "Los Angeles City Hall",
            Bark: "The Government Center for LA City and a local Landmark.",
            Icon: markers.Government,
            Commentary: "The Government Center for LA City and a local Landmark.",
            Position: [34.0549, -118.2426],
          },
        {
        Name: "Stanley Mosk Courthouse",
        Bark: "Local County Courthouse",
        Icon: markers.Government,
        Commentary: "Theres not really anything particularly remarkable about this place outside of it's kinda neat 70s modernist architecture except for one thing. Getting your name changed here is stupidly easy. Like seriously, if you're trans, in LA County and planning to get your name changed, DO IT HERE. This place is it, they have a special counter with usually no line you can go up to in order to do it. There's a guy who'll make sure all your documents are in order help you get everything signed and actually knows what he's doing. All total it took me like 20 minutes on a Thursday afternoon in may to get it done. It might be my quickest and most painless interaction with bureacracy of all time.",
        Position: [34.05541324311076,-118.24723374141067],
        },
        {
            Name: "Hollywood/Highland",
            Bark: "Transit Oriented Mall with a stellar view, adjacent to The Chinese Theater and the Dolby Theatre",
            Icon: markers.Shopping,
            Commentary: "Ovation Hollywood is a pretty odd mall. I don't really know who it's for or who goes here. I mean I do. But I'm a fucking weirdo who thinks these kinds of places are cool (Especially when they're near a Metro Station). However for normal people? I don't really know. I suppose this is kinda the touristy mall of Hollywood. But I feel people would have a better time just walking down Hollywood Boulevard for a bit and spend less money. But I guess that's kind of the point of a tourist trap like this. To waste people's time and get them to spend money. Man I'm being a real dick to this mall. For the record, it's far from the worst mall in Los Angeles. If you can put up with the pretty much nonfunctional escalators it's a nice hangout spot on a hot, SoCal Day. And while I wouldn't recommend you grab any overpriced dreck from a place Like Johnny Rockets (Wayyyyyy overpriced fries) there's always bound to be a street vendor on the sidewalk of Hollywood Boulevard with something interesting. Best possible move, grab a raspado from a cart on the street. Go to the 4th level balcony on the south side of the building where the Kobe Bryant Mural is, and just take in the view of Hollywood Boulevard Whilst enjoying a cold delight. Gaze down upon the hundreds of lives, tourists, artists, homeless, celebrities, families, etc, all scrambling daily to live a out hundreds of unique little stories.",
            Position: [34.10171, -118.339251],
        },
        {
            Name: "Danny's Tacos",
            Bark: "A truly disappointing taco stand",
            Icon: markers.Restaurant,
            overallScore: 3,
            Commentary: "Danny's Tacos is just... Disappointing. I discovered this place biking through downtown to get lunch at Marukai Market and Lock in at the library. I passed it and a similar taco truck on 8th and Fig that advertised a 'Taco Tuesday'. Seeing that me and my girlfriend are on a quest to find the best, affordable shrimp taco truck or stand in the city, I decided to return here on Tuesday with my girlfriend on tuesday expecting some decent, real tacos. We originally wanted to go to the other truck on 8th and fig but it wasn't there for some reason so we decided to opt for danny's tacos. I get to the window and order 6 shrimp tacos and 2 bottles of Jarritos. Three tacos for me and Three for her. I shit you not, the total cost was THIRTY DOLLARS! Yes, that's right! THIRTY WHOLE UNITED STATES DOLLARS! So of course my high ass not wanting to also be a broke ass in front of my girlfriend just orders the food and walks off. The whole time I'm just thinking, 'Man these better be the best tacos I've ever had'. After waiting 20 minutes we finally get our tacos, wrapped in Saran wrap for some reason, and we go to the St. Vincent Alleyway to eat them. My god, these tacos sucked. The tortillas weren't cooked nearly enough to the point my girlfriend's tacos were falling apart at the seams. There was no umami flavor to them, no kick, nothing. I would call them white people tacos but white people tacos aren't this boring. Usually there's a peculiar twist on them that makes the tacos interesting and worth your time even if they're not authentic. But these... There's nothing to them, they're literally just tacos. Plain, unseasoned, mid tacos. Not even the salsa could save it because the Salsa was watery as fuck. It had a horrible consistency that just didn't work. Honestly, all of these complaints are bad, but they're not the worse. I've... probably had worse tacos. But what makes Danny's Tacos egregious is the audacity to charge about 4 dollars a taco for this tripe. I honestly would've saved money by just going to my local white people taco place, and had a better time. If you're looking to shake things up with a new taco place don't bother with Danny's Tacos, it is not worth the price.",
            Position: [34.046461243180765,-118.25545536514856],
        },
        {
            Name: "North Bay Aesthetics",
            Bark: "A truly disappointing taco stand",
            Icon: markers.Medical,
            overallScore: 9,
            Commentary: "North Bay Aesthetics may be THE place in LA for gender affirming hair removal. I was referred here by my gender care specialist at USC and my god am I glad I did. Being run by mostly trans and non binary folks the environment is remarkably inviting. With all the staff being nothing but kind, gentle and understanding of my situation in way I haven't had other places. Additionally, this is one of the few places that bills insurance directly making it more affordable than other providers with better service. Getting electrolysis for my genitals area was a breeze with them because their use of a numbing agent on the area made it so I didn't feel a thing as I got the satisfaction of removing my hair down there for good. And the Laser Hair removal although I'm still waiting on the results already seems to be working. Overall I'll have to continue going in for appointments with them. But so far North Bay Aesthetics is my go to for hair removal. I really only take off points because occasionally they can be a little disorganized in a way I find unprofessional and the music choices are... peculiar (A neo-soul cover of 'lose yourself', paired with a dance pop cover of 'California Dreaming', paired with Ordinary had me feeling like the Peter Griffin Tweaking GIF).",
            Position: [34.06276478423106,-118.35322938227083],
        },
        {
            Name: "Amara Chocolate Cafe",
            Bark: "Phenomal Venezuelan Cafe",
            Icon: markers.Restaurant,
            overallScore: 9,
            Commentary: "Amara Chocolate is a place so spectacular it that it reminds you how fortunate we are to live in a city with so many diverse cultures. Nestled away on Pasadena's Raymond street it's unassuming, a little specialty cafe with a cute name. What's the big deal. But don't let the name and storefront fool you, this cafe is exemplary of Los Angeles Culinary Excellence. Walking in my first time I could feel the welcoming atmosphere all around. A family run business, it's overall okay to just take your time and decide what you want. Which will be necessary with how diverse the menu is, especially if you've never had Venezuelan Food Before. The first time I came in I ended up getting the Iced Venezualan Chocolate Latte, at 6 dollars for a medium it felt like a steal for how good it was. A great pairing with the grocery store sushi I had bought prior. Additionally the staff gave me a free bag of churros, no doubt spotting a new customer and making sure to butter them up. Well played Amara because those churros were spectacular. Quite possibly the best in all of Los Angeles, just the perfect amount of goeyness and crispiness with just enough sugar where it wasn't overpowering but still manages to hit like none other. Amara is so magnificent that after trying it once I knew I'd have to return, and I did! A few weeks later, with my girlfriend, after a long and arduous journey to get my phone back from the Metro lost and found we decided to take the A line up to have a have a late lunch at Amara. We both ordered the Shrimp and Avocado Arepa and my GOD! It was fantastic. After a series of culinary failures (Looking at you Danny's Tacos) finally, excellence. Granted this was my first Arepa so my palate may not be mature and this was after only having half a Rice Krispy Treat for breakfast but the flavors exhibited by the Shrimp Arepa were absolutely exquisite. It was just, perfect, absolutely perfect. A perfect amount of breadiness, a coherent flavor profile between the shrimp, caramelized onions, avocados and what I believe were either bell peppers or mangoes, all made even better a delectable Pink Hot Sauce. While the sauce itself was not particularly hot. It tasted absolutely marvelous on my Arepa. I will say I tried the Venezuelan Chocolate Latte hot this time and the chocolate was a bit too strong when heated so I'd recommend getting it iced. With that being said, my words don't do justice to the perfection of an experience Amara Chocolate truly is. All I can say is that if you haven't tried them, especially if you haven't tried Venezuelan food, I need you to try it NOW! Hop on the A line, get off at Del Mar Station and try Amara NOW! While this may have been my first time trying Venezuelan food, it CERTAINLY will NOT be my last. I would give it a perfect 10/10 however they lose points for how stupid early they close. With Weekend hours being from 8AM-4PM. Pleasepleaseplease open this later, I'd love to have an Arepa for diner. I beg of y'all. But with that being said, Amara Chocolate Cafe is a perfect brunch spot you need to try and it might just be one of the best restaurants in all of Los Angeles. ",
            Position: [34.14479244613875,-118.14904770784607],
        },
        {
            Name: "Marukai Market",
            Bark: "Excellent, affordable, and Convenient Japanese Market",
            Icon: markers.Restaurant,
            overallScore: 8,
            Commentary: "I was told about Marukai Market by a roommate who had just got her college student EBT card and is pretty immersed in Japanese culture. I personally am not nearly as immersed as she is however I am a connesuir of grocery store sushi. So when she, a sushi snob who turns her nose up at the friday $6 sushi special at Ralph's I knew I had to try it. So I got on my bike all the way from USC to Little Tokyo one monday to see what the hype was about. The first time I got just a Shrimp Tempura Bento Bowl, in an attempt to shake things up. It was okay, honestly, I think I may just not really be into bento bowls but for ten bucks it was a pretty amazing meal. However, of course I needed to try the sushi at some point. So two days later I tried the Rainbow Roll Paid for it with my EBT and goddamn. I think Marukai has raised the bar for grocery store sushi. For 13 bucks this is honestly better than some restaurant sushi I've had. If you're looking for a cheap place to grab something to eat that will fill you up. A place that also takes EBT, then I say try Marukai Market. I'll definitely be back on other days as a starving college student looking to get my fix of their fantastic Rainbow Rolls.",
            Position: [34.05023586391059,-118.24211204401931],
        },
        {
            Name: "Highland Park Brewery",
            Bark: "A brewery with good vibe, overpriced drinks and food, and a lot of trannies",
            Icon: markers.Restaurant,
            overallScore: 8,
            Commentary: "Highland Park Brewery is kinda just like most other breweries in LA. Great (but overpriced) drinks and food. And overall a pretty millenialcore vibe to it. Except for one thing... Every other tuesday. From 7PM to 10PM an even is hosted called 'Trans Tuesdays'. All the bougie dolls of the city LOVE to turn out for Trans Tuesdays. Honestly, I probably shouldn't be putting this out there because like if the chasers were to find out about all the dolls hanging out here I may just fuck up the vibe. Oh who am I kidding, a male chaser would never listen to what a woman, let alone a trans woman was saying. We'll be fine. Whether you're looking to flirt, find a friend group, or just hang around other trannies, Highland Park Brewery is THE place to be. Grab a drink, or don't. They don't really care if you buy anything. (Usually me and my girlfriend eat dinner before arriving by either cooking something or grabbing the $7 sushi rolls at Ramen Maruya in Little Tokyo, in order to save money). Go up to a table, pretty much everyone is there to meet new people and hangout and therefore is overall pretty chill if you just approach them without much preamble. The event skews heavily towards white translesbians, however there are quite a few trans men who also frequent the establishment. Additionally there's usually some butch cis lesbians and a few cis femme lesbians. But generally this is a pretty doll heavy event for some reason. Although it is open to all queer people. So if you're a tranny who likes hanging around with other trannies. Come on down to Highland Park Brewery. 8/10",
            Position: [34.0657422,-118.233389],
        },
        {
            Name: "Big Fish",
            Bark: "Fucking Amazing Fish Place",
            Icon: markers.Restaurant,
            overallScore: 9,
            Commentary: "Don't let the unassuming exterior and interior fool you. This place has got some of the best fried shrimp in LA. Get the 30 pc basket with some fries and a 7up with a friend by Manhattan Beach and sweetie, ooh, you are in for a fucking good time. They must be putting crack in this seasoning because something about it just stays hittin'. 9/10",
            Position: [33.96226367493238,-118.32666941428812],
        },
        {
            Name: "Denny's at 8th and Fig",
            Bark: "Fuckass Denny's",
            Icon: markers.Restaurant,
            overallScore: 1,
            Commentary: "FUUUUUUCK this transphobic Denny's. Okay so I was coming down here with my girls after trans tuesday right. My beloved girlfriend Ashley and my friends Kimmy and Isa and one of Kimmy's friends I never saw again. Five trannies walking into a Diner on a 10:45 PM adventure to grab some cheap food on a Tuesday night, right? WRONG! We get in and the hostess says it'll be a 15 minute wait. There's a fuck ton of table open and clean but whatever, we oblige and wait in their little area. Isa's on her phone semi-ironically getting excited over the Denny's rewards app. Me and Ashley are doing some Lezzy shit. Being cordial and all. 15 minutes minutes go by and still nothing back from them. By then Kimmy and Her friend are now also wrapped up in exploring the Denny's rewards program. Multiple large parties have left their table. Most of the restaurant is empty. And yet we're still unseated. Eventually Kimmy gets bored and decides to take her chance at the claw machine. We all try to help her win something but to no avail the gambling machine just ends up wasting her 15 dollars. It's now 11:15 and still we hear nothing. Eventually while we play on the claw machine, a couple comes in and sits at the front waiting for a table. We go back to front and continue to wait after our failed attempt at the claw machine. Waiting for our table that was supposed to be ready 15 minutes ago. we continue to wait but as the night drags on and we reach closer to midnight at 11:29 we realize we're not getting that table. So we concede and leave the Denny's for the Taco Bell Cantina up the street. And I shit you not, as soon as we close the door, not even out of the line of the sight, they seat the couple. THE COUPLE THAT GOT THERE AFTER US. WHAT. THE. FUCK. Bullshit ass Denny's, I vow to never set foot in there again. I would say go to the IHOP around the corner but that IHOP sucks ass.",
            Position: [34.04718407916214,-118.26167945771668],
        },
        {
            Name: "D-Town Burger Bar",
            Bark: "A 50s style diner with an immaculate vibe and excellent sides",
            Icon: markers.Restaurant,
            overallScore: 8,
            Commentary: "I wasn't really sure what to expect when I tried the D-Town Burger Bar. When me and my girlfriend first walked past, as diner connesuirs, we thought the vibes looked interesting. We were also lured by it running into the wee hours of the night, closing at 2AM, something uncommon with downtown establishments. but of course you the vibes may be hiding an overpriced menu and shit quality. After a few weeks of our initial discovery of the place we returned to order A veggie burger for both of us, onion rings for her, fries for me, a strawberry banana milkshake for her, and a chocolate milkshake for me. The veggie burgers were, okay, certainly not the worst I've ever had but the mushy texture of the patty didn't do much for me. It was just fine. Aditionally I tried my girlfriend's onion rings and found them largely disappointing. Not terrible, just... fine again. The batter just wasn't seasoned enough which made for a somewhat bland set of onion rings. \n\n Now you may be wondering, Xara if it's just okay, why'd you give it an 8/10. Well, while other parts of the menu I found underwhelming the fries and the shake were so phenomenal that it raised it up significantly. I recieved some seasoned classic style fries which are always hit or miss with me because the risk of overseasoning and undercooking is so high. However, they managed to cook and season it to perfection making for an absolutely delectable part of the meal. And as for the shakes, well honestly I think they may just be the best milkshakes in Los Angeles County. Especially for 5 dollars these milkshakes felt like they were made with love. I mean you really could taste the chocolate ice cream within it in a way that most shakes falter on. It felt like I was drinking ice cream which is something I don't always get with milkshakes which often turns me off to them. However, D-Town Burger Bar stands out as a fast casual establishment that resists slop and still puts effort into it's food at a somewhat reasonable price. I say if you want a nice midday snack. Stop in to D-Town Burger Bar, you won't regret it.",
            Position: [34.046192249085564,-118.25155438429512],
        },
        {
            Name: "IHOP at 8th and Flower",
            Bark: "Fuckass IHOP",
            Icon: markers.Restaurant,
            overallScore: 3,
            Commentary: "While this IHOP at least isn't transphobic, it tastes like fucking ass. Like my god it had been a while since I had last gone to IHOP when I came to this fuckassian establishment and I do NOT remember it being this ass. Me and my girlfriend Ashley ended up here one night when she was hanging around at my place on MLK day of '26 watching the Fallout show and getting fucked up off some edibles. After realizing we were hungry and had the munchies for pancakes we hopped on the E line and headed to local IHOP to grab some at around 8PM. So late-ish into the night. Lemme tell you, not even being absolutely stoned out of my mind on edibles with my beautiful girlfriend could save them dry ass pancakes. And the hashbrowns, I mean they didn't even try to hide that they were frozen. That shit came out in a straight up fucking perfect square. The only good part of this was lowkey probably just the hot chocolate. And nothing else. And the worst part, it wasn't even cheap. A shortstack of pancakes and some hashbrowns for both of us and hot chocolate and tea for me and her respectively cost like 60 bucks total. So yeah fuck IHOP, that shit was ass. I would say go to the Denny's nextdoor but that Denny's is transphobic so lwk idk what to even eat late at night in downtown. I guess you just gonna starve bitch.",
            Position: [34.04704941581246,-118.26008078829142],
        },
        {
            Name: "University of Southern California",
            Bark: "Iconic and overpriced local private University",
            Icon: markers.Education,
            Commentary: "The University of Southern California, like the region it resides in, is a campus of contrasts and contradictions. The simulacra of elegance created by the faux-red brick architecture reminiscent of an East Coast Ivy contrasts with the drab shopping plazas, dilapidated housing, and rapidly aging street infrastructure. A staunchly conservative, patriarchal, queerphobic, and racist and bro-ish Greek culture contrasts with a diverse, beautifully confusing, and vibrant queer culture. Some students' flashy luxury cars contrast with other students at one of the four nearby Metro stations commuting home, saving every dime to pay for an education here. Tuitions rise and staff are laid off while multimillion dollar training facilities for our fledgling sports teams are erected around us. USC is a microcosm of the unending beautiful, confounding, contrasts of this city. As much as the administration may want to pretend these conflicts and contradictions are not a part of our identity, the truth is that the University wouldn't be the same without it. Outside of the excellent faculty, fascinating classes, and alumni network, the constant culture clashes that regularly arise controversy are what keeps me here as a student. It creates a culture that can be incredibly stimulating if you seek it out. Every day theres a new issue, a new story, a new tragedy, and we all as students, as faculty, learn how to deal with it together. And after all, is that not what college is for.",
            Position: [34.026213, -118.2877316],
          },
    ]
    
    const [selectedEntry, setSelectedEntry] = useState(Entries[0]);
    
    const loadContent = (desc) => {
        descBox.current.innerHtml = desc;
    }
    
    
    
    const listItemsMarkers = Entries.map((Entry, index) =>
                                  
                                  <Marker position={Entry.Position} icon={defaultIcon({IconUrl: Entry.Icon})}>
                                    <Popup>
                                        {Entry.Name}<br />
                                        {Entry.Bark}<br />
                                        {Entry.overallScore > 0 ? (
                                        <>
                                            {stars.map((_, index) => (
                                            <img
                                                style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                                src={Entry.overallScore > index ? starFull : starEmpty}
                                                className='star'
                                            />
                                            ))}
                                            <br/>
                                        </>
                                        ) : null}
                                        
                          
                                          <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => setSelectedEntry(Entry)}>
                                          More Info
                                          </Button>
                                    </Popup>
                                  </Marker>
                                  );
    
    const listItemsCities = cityBoundaries.map(({entry, index}) => (
        <Polygon
           key={entry.Name}
           positions={entry.coords}
           pathOptions={{ color: 'red', fillColor: colors[entry.overallScore], fillOpacity: 0.6 }}
                                    
         >
            <Popup>
                {entry.Name}<br />
                   {entry.Bark}<br/>
                   {entry.overallScore > 0 ? (
                        <>
                            {stars.map((_, index) => (
                            <img
                                style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                src={entry.overallScore > index ? starFull : starEmpty}
                                className='star'
                            />
                            ))}
                            <br/>
                        </>
                        ) : null}
                <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => setSelectedEntry(entry)}>
                  More Info
                  </Button>
            </Popup>
        </Polygon>
       ));
    
    const listItemsNeighborhoods = neighborhoodBoundaries.map(({ entry, index }) => (
       <Polygon
         key={entry.Name}
         positions={entry.coords}
         pathOptions={{ color: 'purple', fillColor: colors[entry.overallScore], fillOpacity: 0.6 }}
                            
       >
        <Popup>
            {entry.Name}<br />
               {entry.Bark}<br/>
               {entry.overallScore > 0 ? (
                        <>
                            {stars.map((_, index) => (
                            <img
                                style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                src={entry.overallScore > index ? starFull : starEmpty}
                                className='star'
                            />
                            ))}
                            <br/>
                        </>
                        ) : null}
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => setSelectedEntry(entry)}>
              More Info
              </Button>
        </Popup>
        </Polygon>
     ));
    
    const listItemsMetro = transitLines.map(({ entry, index}) => (
       <Polyline
         key={entry.Name}
         positions={entry.coords}
         pathOptions={{ color: entry.Color }}
                            
       >
        <Popup>
            {entry.Name}<br />
               {entry.Bark}
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => setSelectedEntry(entry)}>
              More Info
              </Button>
        </Popup>
        </Polyline>
     ));
    return (
            <ThemeProvider theme={rose}>
            <Window resizable className='window' style={{ display: 'block',width: '80%', height: '75vh' }}>
            <WindowHeader className='window-title' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Xara's Guide</span>
            <Button style={{ marginRight: '2px', width: '20px', height: '20px', padding: 0 }} onClick={() => handleRedirect('/Backpage')}>
            <span style={{ fontWeight: 'bold', fontSize: '12px' }}>✕</span>
            </Button>
            </WindowHeader>
            
            <WindowContent style={{ height: 'calc(100% - 33px)', padding: 0 }}>
                <div id='XarasGuideDesktop' style={{ height: '100%' }}>
                    <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex' }}>
                
                        <div style={{  flex: 2, height: '100%'}}>
                            <ScrollView style={{ height: '100%' }}>
                                <h2>{selectedEntry.Name}</h2>
                                
                                <div style={{ padding: '1rem' }}>
                                    {selectedEntry.overallScore > 0 ? (
                                    <>
                                        Overall Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.overallScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.walkabilityScore > 0 ? (
                                    <>
                                        Walkability Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.walkabilityScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.queernessScore > 0 ? (
                                    <>
                                        Queerness Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.queernessScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.Commentary}
                                </div>
                            </ScrollView>
                        </div>
                        
                        <div style={{  flex: 3, height: '100%'}}>
                            <Frame variant='well' className='footer' style={{  height: '100%', width: '100%' }}>
                                <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                                    <MapContainer
                                    style={{ flex: 1, height: '100%', width: '100%', minHeight: 0 }}
                                    center={[34.0549, -118.2426]}
                                    zoom={13}
                                    scrollWheelZoom={false}
                                    >
                                    {listItemsMetro}
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {listItemsNeighborhoods}
                                    {listItemsCities}
                                    {listItemsMarkers}
                                    </MapContainer>
                                </div>
                            </Frame>
                        </div>
                        
                    
                    </Frame>
                </div>
            
                <div id='XarasGuideMobile' style={{ height: '100%' }}>
                    <Frame variant='well' className='footer' style={{ height: '100%', margin: 0, display: 'flex', flexDirection: 'column-reverse' }}>
                
                        <div style={{  flex: 3, width: '100%', height: '100%', overflow: 'hidden'}}>
                            <ScrollView style={{ height: '100%' }}>
                                <h2>{selectedEntry.Name}</h2>
                                
                                <div style={{ padding: '1rem' }}>
                                    {selectedEntry.overallScore > 0 ? (
                                    <>
                                        Overall Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.overallScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.walkabilityScore > 0 ? (
                                    <>
                                        Walkability Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.walkabilityScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.queernessScore > 0 ? (
                                    <>
                                        Queerness Score:
                                        <br/>
                                        {stars.map((_, index) => (
                                        <img
                                            style={{aspectRatio: 1, height: "max(.2em, .7em + .9cqi)"}}
                                            src={selectedEntry.queernessScore > index ? starFull : starEmpty}
                                            className='star'
                                        />
                                        ))}
                                        <br/>
                                    </>
                                    ) : null}
                                    {selectedEntry.Commentary.split('\n\n').map((para, i) => (
                                        <p key={i}>{para}</p>
                                        ))}
                                </div>
                            </ScrollView>
                        </div>
                        
                        <div style={{  flex: 5, width: '100%'}}>
                            <Frame variant='well' className='footer' style={{  height: '100%', width: '100%' }}>
                                <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                                    <MapContainer
                                    style={{ flex: 1, height: '100%', width: '100%', minHeight: 0 }}
                                    center={[34.0549, -118.2426]}
                                    zoom={13}
                                    scrollWheelZoom={false}
                                    >
                                    {listItemsMetro}
                                    <TileLayer
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    {listItemsNeighborhoods}
                                    {listItemsCities}
                                    {listItemsMarkers}
                                    </MapContainer>
                                </div>
                            </Frame>
                        </div>
                        
                    
                    </Frame>
                </div>
            

            
            </WindowContent>
            
          </Window>
          
          
    </ThemeProvider>
  );
}

export default AboutPage;
